import Component from '../core/Component'
import { queryAll } from '../utils/dom'

export default class PressFormFilter extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            radioGroup: null,
            dateGroup: null,
            dates: []
        }

        this.timer = Date.now()
    }

    prepare() {
        this.ref.radioGroup.addEventListener('change', ::this.handleRadioChange)
        this.ref.dates.forEach(element => element.addEventListener('change', ::this.handleDateChange))
    }

    handleRadioChange(event) {
        this.timer = Date.now()
        this.ref.dates.forEach(element => {
            const datepicker = Component.getFromElement(element)

            if (datepicker) {
                datepicker.reset(true)
            }
        })
    }

    handleDateChange() {
        if (Date.now() < this.timer + 200) {
            return
        }

        queryAll('input[type="radio"]', this.ref.radioGroup)
            .forEach(input => input.checked = false)
    }
}